export const PASSWORD_INVALID_LENGTH = 'password_invalid_length';
export const INVALID_PASSWORD_LENGTH = 'invalid_password_length';
export const PASSWORD_MISSING_UPPERCASE = 'password_missing_uppercase';
export const PASSWORD_MISSING_LOWERCASE = 'password_missing_lowercase';
export const PASSWORD_MISSING_NUMBER = 'password_missing_number';
export const PASSWORD_REQUIRED = 'password_required';
export const PASSWORD_MATCH = 'password_match';
export const PASSWORD_MISSING_SPECIAL_CHARACTER =
    'password_missing_special_character';
